import styles from './PdfPreview.module.scss'

const PdfPreview = ({ file }) => {
  return <iframe src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(file)}`} className={styles.frame}   frameborder='0' />
} 

export default PdfPreview


